import { FirestoreCityRepository } from './repositories/FirestoreCityRepository';
import { FirestoreLicenseRepository } from './repositories/FirestoreLicenseRepository';
import { FirestoreListingRepository } from './repositories/FirestoreListingRepository';
import { FirestorePropertyRepository } from './repositories/FirestorePropertyRepository';
import { HttpApiCityRepository } from './repositories/HttpApiCityRepository';
import { HttpApiLicenseRepository } from './repositories/HttpApiLicenseRepository';
import { HttpApiListingRepository } from './repositories/HttpApiListingRepository';
import { HttpApiPropertyRepository } from './repositories/HttpApiPropertyRepository';
import {
  CompositeCityRepository,
  getCityWriteRoutingFromEnv
} from './repositories/CompositeCityRepository';
import {
  CompositeLicenseRepository,
  getLicenseWriteRoutingFromEnv
} from './repositories/CompositeLicenseRepository';
import {
  CompositeListingRepository,
  getListingWriteRoutingFromEnv
} from './repositories/CompositeListingRepository';
import { CompositePropertyRepository } from './repositories/CompositePropertyRepository';

const cityRepository = new CompositeCityRepository({
  firestoreRepo: new FirestoreCityRepository(),
  apiRepo: new HttpApiCityRepository(),
  writeRouting: getCityWriteRoutingFromEnv(process.env)
});

const licenseRepository = new CompositeLicenseRepository({
  firestoreRepo: new FirestoreLicenseRepository(),
  apiRepo: new HttpApiLicenseRepository(),
  writeRouting: getLicenseWriteRoutingFromEnv(process.env)
});

const listingRepository = new CompositeListingRepository({
  firestoreRepo: new FirestoreListingRepository(),
  apiRepo: new HttpApiListingRepository(),
  writeRouting: getListingWriteRoutingFromEnv(process.env)
});

const propertyRepository = new CompositePropertyRepository({
  firestoreRepo: new FirestorePropertyRepository(),
  apiRepo: new HttpApiPropertyRepository()
});

export { cityRepository, licenseRepository, listingRepository, propertyRepository };
